import interact from 'interactjs'
import Vue from 'vue'
import { PopupManager } from 'element-ui/lib/utils/popup'
import * as CssHelper from '@common/utils/css'

export function mountNode(VueComponent, props) {
    const instance = Vue.extend({})
    const newInstance = new instance({
        el: document.createElement('div'),
        render(h) {
            // 如果是字符串则解析为title 或者传入构造参数
            return h(VueComponent, {
                props: props,
                style: {
                    zIndex: PopupManager.nextZIndex()
                }
            })
        }
    }).$mount()
    return newInstance
}

// 拖动放大缩小
export function interactive(container, handle) {
    const position = { x: 0, y: 0 }
    handle = handle || container.$el
    interact(handle).draggable({
            cursorChecker: (action, interatable, element, interacting) => {
                return container.$el.parentNode === document.body ? 'move' : ''
            },
            listeners: {
                move(event) {
                    if (container.$el.parentNode !== document.body) return
                    const element = container.$el
                    const transform = CssHelper.getTranslate(element)
                    position.x = transform.x + event.dx
                    position.y = transform.y + event.dy
                    element.style.transform = `translate(${position.x}px, ${position.y}px)`
                }
            }
        })
        // 禁用弹出框得resize能力
        // interact(container.$el)
        //     .resizable({
        //         edges: Object.assign({
        //             left: true,
        //             top: true,
        //             bottom: true,
        //             right: true
        //         }),
        //         cursorChecker: (action, interatable, element, interacting) => {
        //             if (container.$el.parentNode !== document.body) return ''
        //             if (action.edges) {
        //                 if ((action.edges.top && action.edges.left) || (action.edges.bottom && action.edges.right)) {
        //                     return 'se-resize'
        //                 }
        //                 if ((action.edges.top && action.edges.right) || (action.edges.bottom && action.edges.left)) {
        //                     return 'ne-resize'
        //                 }
        //                 if (action.edges.top) return 's-resize'
        //                 if (action.edges.left) return 'e-resize'
        //                 if (action.edges.bottom) return 's-resize'
        //                 if (action.edges.right) return 'e-resize'
        //             }
        //             return ''
        //         }
        //     })
        //     .on('resizemove', event => {
        //         if (container.$el.parentNode !== document.body) return
        //         let { x, y } = event.target.dataset
        //         x = parseFloat(x) || 0
        //         y = parseFloat(y) || 0
        //         const transform = CssHelper.getTranslate(event.target)
        //         position.x = transform.x + event.deltaRect.left
        //         position.y = transform.y + event.deltaRect.top

    //         Object.assign(event.target.style, {
    //             width: `${event.rect.width}px`,
    //             height: `${event.rect.height}px`,
    //             transform: `translate(${position.x}px, ${position.y}px)`
    //         })

    //         Object.assign(event.target.dataset, { x, y })
    //     })
}